import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from './traits';
import loadCommands from './commands';
import { dynamicTableRef } from './consts';

export default grapesjs.plugins.add('gjs-data-table-dynamic', (editor, opts = {}) => {
  const default_commands = {
    ddt_custom_code: 'ddt:open-modal',
  };

  let options = {
    pfx: 'data-table-dynamic',
    blocks: [dynamicTableRef],
    ref: dynamicTableRef,
    defaultStyle: true,
    labelTable: 'Dynamic Table',
    labelFinderName: 'Filters',
    labelCMSCategory: 'CMS',
    labelColName: 'Collection',
    labelFieldName: 'Collection Fields',
    toolbarBtnCode: {},
    commands: default_commands,
    ...opts,
  };
  loadComponents(editor, options);
  loadBlocks(editor, options);
  loadTraits(editor, options);
  loadCommands(editor, options);
});
